import {AfterViewInit, Component, HostBinding, OnInit, TemplateRef, ViewChild, inject} from '@angular/core';
import { FilteringLogic, IgxStringFilteringOperand } from '@infragistics/igniteui-angular/core';
import {
  IGridEditDoneEventArgs, IGridEditEventArgs, IgxColumnComponent, IgxExcelExporterService, IgxPdfExporterService,
  IgxGridCell, IgxGridStateDirective, RowType
} from '@infragistics/igniteui-angular/grids/core';
import { IGX_GRID_DIRECTIVES, IgxGridComponent, IgxGridModule } from '@infragistics/igniteui-angular/grids/grid';
import { IgxIconComponent } from '@infragistics/igniteui-angular/icon';
import { IgxButtonDirective, IgxButtonModule, IgxFocusDirective, IgxRippleDirective, IgxRippleModule, IgxTextSelectionDirective } from '@infragistics/igniteui-angular/directives';
import {IGX_INPUT_GROUP_DIRECTIVES, IgxInputGroupComponent} from '@infragistics/igniteui-angular/input-group';
import { IGX_ACTION_STRIP_DIRECTIVES, IgxActionStripModule } from '@infragistics/igniteui-angular/action-strip';
import {ClsUtil} from '../../../util/cls-util';
import {ClsConfig} from '../../../util/cls-config';
import {AppPresupuestosService} from '../../../core/services/app-presupuestos.service';
import {ClsObjCrudCatalogos} from '../../../clases-pu/02-catalogos/cls-obj-crud-catalogos';
import {INeodataGridCell, INeodataMenu} from '../../../core/models/interfaces/generico-interface';
import {EnumMCGenerales} from '../../../core/models/enum/enum-menu-contextual';
import {ClsObjGenerico} from '../../../clases-pu/util/cls-obj-generico';
import {EnumTresPuntos} from '../../../core/models/enum/enum-tres-puntos';
import {FiltroGeneralModernoComponent} from '../../util/controles/filtro-general-moderno/filtro-general-moderno.component';
import {VtnGenericaComponent} from '../../util/ventanas/vtn-generica/vtn-generica.component';
import {TranslateModule} from '@ngx-translate/core';
import {ContextMenuGenericoComponent} from '../../util/controles/context-menu-generico/context-menu-generico.component';
import {UppercaseDirective} from '../../../core/directivas/uppercase.directive';
import {FormsModule} from '@angular/forms';
import {MasOpcionesGridComponent} from '../../util/controles/mas-opciones-grid/mas-opciones-grid.component';
import {ClsClientes, ClsContactoCliente} from 'src/app/core/models/cls-catalogos';
import {EnumMasOpciones} from "../../../core/models/enum/enum-mas-opciones";
import {EnumNombresGrids} from "../../../core/models/enum/enum-nombres-grids";
import {ClsObjConfiguracionGrid} from "../../../clases-pu/util/cls-obj-configuracion-grid";
import {TipoMensajesService} from "../../../core/services/tipo-mensajes.service";
import {SummaryPipeNeoPipe} from "../../../core/pipes/summary-pipe-neo.pipe";
import { CrearComponenteDinamicoService } from '../../../core/services/crear-componente-dinamico.service';

@Component({
  selector: 'app-clientes-contactos',
  templateUrl: './contactos-clientes.component.html',
  styleUrls: ['./contactos-clientes.component.scss'],
  imports: [
    IgxGridModule,
    IGX_GRID_DIRECTIVES,
    TranslateModule,
    FiltroGeneralModernoComponent,
    IgxIconComponent,
    MasOpcionesGridComponent,
    IGX_INPUT_GROUP_DIRECTIVES,
    UppercaseDirective,
    IgxTextSelectionDirective,
    IgxFocusDirective,
    IgxActionStripModule,
    IGX_ACTION_STRIP_DIRECTIVES,
    ContextMenuGenericoComponent,
    IgxButtonModule,
    IgxButtonDirective,
    IgxRippleModule,
    IgxRippleDirective,
    FormsModule,
    SummaryPipeNeoPipe,
    IgxInputGroupComponent
  ],
  providers: [SummaryPipeNeoPipe]
})
export class ContactosClientesComponent extends ClsConfig implements OnInit, AfterViewInit {
  private infPpto = inject(AppPresupuestosService);
  private tipoMsg = inject(TipoMensajesService);
  private summaryPipe = inject(SummaryPipeNeoPipe);
  private excelExportService = inject(IgxExcelExporterService);
  private pdfExportService = inject(IgxPdfExporterService);
  private crearCompDinamico = inject(CrearComponenteDinamicoService);

  @ViewChild('gridContactoClientes', {read: IgxGridComponent, static: true})
  public gridContactoClientes: IgxGridComponent;
  @ViewChild('filtroGeneral', {read: FiltroGeneralModernoComponent, static: true})
  public filtroGeneral: FiltroGeneralModernoComponent;

  public errorAlCargar: boolean;
  public dataContactoClientes: ClsContactoCliente[] = [];
  public activarBotones = false;
  public dataClientes: ClsClientes;
  // mostrar actionStrip
  public showActionStrip = true;
  // clase catalogos
  public mObjCRUDCatalogos: ClsObjCrudCatalogos = new ClsObjCrudCatalogos();
  private mObjGenerico: ClsObjGenerico = new ClsObjGenerico();
  // menucontextual
  public verContextMenu = false;
  public contextmenuX = 0;
  public contextmenuY = 0;
  public cellMenuContextaul: IgxGridCell;
  public menus: INeodataMenu[] = [];
  public lengthMenu: number;
  // CONFIGGRIDS: definir cada ng-Template que tengamos en el HTML
  @ViewChild('nombreClienteContactoHeaderTemplate', {static: true}) public nombreClienteContactoHeaderTemplate: TemplateRef<any>;
  @ViewChild('nombreClienteContactoEditorTemplate', {static: true}) public nombreClienteContactoEditorTemplate: TemplateRef<any>;
  @ViewChild('cargoClienteContactoHeaderTemplate', {static: true}) public cargoClienteContactoHeaderTemplate: TemplateRef<any>;
  @ViewChild('cargoClienteContactoEditorTemplate', {static: true}) public cargoClienteContactoEditorTemplate: TemplateRef<any>;
  @ViewChild('telefonoClienteContactoEditorTemplate', {static: true}) public telefonoClienteContactoEditorTemplate: TemplateRef<any>;
  @ViewChild('mailClienteContactoEditorTemplate', {static: true}) public mailClienteContactoEditorTemplate: TemplateRef<any>;
  @ViewChild(IgxGridStateDirective, {static: true}) public state;
  // Grid Layout
  public mObjConfigGrids: ClsObjConfiguracionGrid;
  // ConfigGridLayout
  public optionsGridLocal = {
    cellSelection: true,
    rowSelection: false,
    filtering: false,
    advancedFiltering: true,
    paging: true,
    sorting: false,
    groupBy: true,
    columns: true,
    expansion: true,
    rowPinning: false,
    columnSelection: true
  };
  // ajuste de texto
  @HostBinding('class') public themesClass = 'noAjustarTexto';
  public clicked = false;
  public vtnGenerico: VtnGenericaComponent;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.gridContactoClientes.data = [];
  }

  public ngAfterViewInit() {
    // se genera la plantilla default del grid
    const stateDefault = this.state.getState(true);

    this.mObjConfigGrids.saveGridState(EnumNombresGrids.Clientes, true, stateDefault, '', this.clicked);
    const state = this.mObjConfigGrids.initGridState(EnumNombresGrids.Clientes);
    if (!ClsUtil.esNulo(state[0])) {
      this.state.setState(state[0]);
    }
    this.clicked = state[1];
    const result: { themesClass: string, clicked: boolean } = ClsUtil.ajustarTexto(this.clicked);
    this.themesClass = result.themesClass;
    this.clicked = result.clicked;
  }

  public onColumnInit(column: IgxColumnComponent) {
    switch (column.field) {
      case 'NombreClienteContacto':
        column.headerTemplate = this.nombreClienteContactoHeaderTemplate;
        column.inlineEditorTemplate = this.nombreClienteContactoEditorTemplate;
        column.summaries = this.summaryPipe.transform('filasSummary');
        break;
      case 'CargoClienteContacto':
        column.headerTemplate = this.cargoClienteContactoHeaderTemplate;
        column.inlineEditorTemplate = this.cargoClienteContactoEditorTemplate;
        break;
      case 'TelefonoClienteContacto':
        column.inlineEditorTemplate = this.telefonoClienteContactoEditorTemplate;
        break;
      case 'MailClienteContacto':
        column.inlineEditorTemplate = this.mailClienteContactoEditorTemplate;
        break;
    }
  }

  public async cargarContactoClientes() {
    if (!ClsUtil.esNulo(this.infPpto.organizacion)) {
      this.dataContactoClientes = [];
      try {
        this.tipoMsg.mostrarWaitDialog('MENSAJES.WAIT.GET_CATALOGOS');
        this.mObjCRUDCatalogos.dataCatalogo = [];
        this.dataContactoClientes = [];
        await this.mObjCRUDCatalogos.obtenerCatalogo(0, 'ConsultarClientesContactos2021');
        // filtrar los contactos del cliente seleccionado
        this.mObjCRUDCatalogos.dataCatalogo = this.mObjCRUDCatalogos.dataCatalogo.filter(value => ClsUtil.bigintX(value.IdCliente) === ClsUtil.bigintX(this.dataClientes.IdCliente));
        this.mObjCRUDCatalogos.dataCatalogo.forEach(contacto => {
          const contactoCliente: ClsContactoCliente = {
            IdClienteContacto: contacto.IdClienteContacto,
            NombreClienteContacto: contacto.NombreClienteContacto,
            CargoClienteContacto: contacto.CargoClienteContacto,
            TelefonoClienteContacto: contacto.TelefonoClienteContacto,
            MailClienteContacto: contacto.MailClienteContacto,
          };
          this.dataContactoClientes.push(contactoCliente);
        });
        this.gridContactoClientes.data = this.dataContactoClientes;
        this.errorAlCargar = false;
        this.tipoMsg.cerrarWaitDialog();
      } catch (e) {
        this.tipoMsg.cerrarWaitDialog();
        this.errorAlCargar = true;
        this.tipoMsg.mostrarMsg(e.message, 'error');
      }
    }
  }

  public rowEditEnter() {
    this.showActionStrip = false;
  }

  public rowEditExit() {
    this.showActionStrip = true;
  }

  public filterInput(filtro: string) {
    this.gridContactoClientes.filteringLogic = FilteringLogic.Or;
    this.gridContactoClientes.filterGlobal(filtro, IgxStringFilteringOperand.instance().condition('contains'));
  }

  public async addUpdateContactoCliente(contactoCliente: IGridEditDoneEventArgs) {
    const newValor: ClsContactoCliente = contactoCliente.newValue;
    const oldValor: ClsContactoCliente = contactoCliente.oldValue;
    if (contactoCliente.isAddRow) {
      await this.agregarModificarContactoCliente(newValor, oldValor, contactoCliente.isAddRow);
    } else {
      // al editar los campos, validar que sean distintos para ocupar el servicio
      if (this.mObjCRUDCatalogos.validarSiCambioCamposCatalogos(newValor, oldValor, EnumTresPuntos.ContactoCliente)) {
        await this.agregarModificarContactoCliente(newValor, oldValor, contactoCliente.isAddRow);
      }
    }
  }

  private async agregarModificarContactoCliente(newContactoCliente: ClsContactoCliente, oldContactoCliente: ClsContactoCliente, isAddRow: boolean) {
    let respuesta: bigint;
    const objCatalogo: ClsContactoCliente = new ClsContactoCliente();
    try {
      objCatalogo.IdClienteContacto = isAddRow ? BigInt(0) : newContactoCliente.IdClienteContacto;
      objCatalogo.IdCliente = this.dataClientes.IdCliente;
      objCatalogo.NombreClienteContacto = ClsUtil.esNulo(newContactoCliente.NombreClienteContacto) ? '' : newContactoCliente.NombreClienteContacto.toUpperCase();
      objCatalogo.CargoClienteContacto = ClsUtil.esNulo(newContactoCliente.CargoClienteContacto) ? '' : newContactoCliente.CargoClienteContacto;
      objCatalogo.TelefonoClienteContacto = ClsUtil.esNulo(newContactoCliente.TelefonoClienteContacto) ? '0' : newContactoCliente.TelefonoClienteContacto;
      objCatalogo.MailClienteContacto = ClsUtil.esNulo(newContactoCliente.MailClienteContacto) ? '' : newContactoCliente.MailClienteContacto;
      this.tipoMsg.mostrarWaitDialog(isAddRow ? 'MENSAJES.WAIT.GUARDANDO_CATALOGO' : 'MENSAJES.WAIT.MODIFICANDO_CATALOGO');
      respuesta = await this.mObjCRUDCatalogos.agregarModificarCatalogo([objCatalogo], 'ClientesContactosRegistraActualiza2021');
      if (isAddRow) {
        newContactoCliente.IdClienteContacto = respuesta;
      }
      this.tipoMsg.mostrarToast(isAddRow ? 'MENSAJES.TOAS.GUARDANDO_CATALOGO' : 'MENSAJES.TOAS.MODIFICANDO_CATALOGO');
      this.tipoMsg.cerrarWaitDialog();
    } catch (e) {
      this.tipoMsg.cerrarWaitDialog();
      this.cancelarAddUpdateContactoClientes(newContactoCliente, oldContactoCliente, isAddRow);
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  // se ocupa cuando manda error al intentar agregar o modificar,
  // al agregar si manda error se quita la fila del grid
  // al editar si manda error se regresa a los valores anteriores
  private cancelarAddUpdateContactoClientes(newContactoCliente: ClsContactoCliente, oldContactoCliente: ClsContactoCliente, isAddRow: boolean) {
    if (isAddRow) {
      this.gridContactoClientes.deleteRowById(newContactoCliente.IdClienteContacto);
    } else {
      this.gridContactoClientes.updateRow(oldContactoCliente, oldContactoCliente.IdClienteContacto);
    }
  }

  private async eliminarContactoClientes(rowContext: RowType) {
    const contactoCliente: ClsContactoCliente = rowContext.data;
    try {
      this.tipoMsg.mostrarWaitDialog('MENSAJES.WAIT.ELIMINANDO_CATALOGO', undefined, 'delete');
      await this.mObjCRUDCatalogos.eliminarCatalogo(contactoCliente.IdClienteContacto, 'EliminarClientesContactos2021');
      this.gridContactoClientes.getRowByIndex(rowContext.index).delete();
      this.tipoMsg.mostrarToast('MENSAJES.TOAS.ELIMINANDO_CATALOGO');
      this.tipoMsg.cerrarWaitDialog();
    } catch (e) {
      this.tipoMsg.cerrarWaitDialog();
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  // se ocupa el evento rowEdit para validar uno o varios campos obligatorios,
  // si falta algun campo de todo la fila se cancela la edicio y se manda mensaje que campos faltan
  // en caso de ser todo OK, procede al agregado o modificado
  public validarContactoCliente(contactoCliente: IGridEditEventArgs) {
    const valor: ClsContactoCliente = contactoCliente.newValue;
    contactoCliente.cancel = this.esValido(valor, contactoCliente.isAddRow);
  }

  // en este caso se pasa el valor de la cliente, ya que es el unico campo obligatorio,
  // en caso de ser mas campos a validar, pasar toda la clase
  private esValido(contactoCliente: ClsContactoCliente, isAddRow: boolean): boolean {
    // validar campos obligatorios
    if (ClsUtil.esNulo(contactoCliente.NombreClienteContacto)) {
      this.tipoMsg.mostrarMsg(this.mObjGenerico.getTranslationsAlertValidarCampos(this.mObjGenerico.getTranslationValidarColuma('GRIDS.CONTACTO_CLIENTE.COL_CONTACTO')));
      return true;
    }
    if (ClsUtil.esNulo(contactoCliente.CargoClienteContacto)) {
      this.tipoMsg.mostrarMsg(this.mObjGenerico.getTranslationsAlertValidarCampos(this.mObjGenerico.getTranslationValidarColuma('GRIDS.CONTACTO_CLIENTE.COL_CARGO')));
      return true;
    }
    // validar cuando se agrega nuevo registro
    if (isAddRow) {
      if (this.dataContactoClientes.findIndex(cliente2 => cliente2.NombreClienteContacto === contactoCliente.NombreClienteContacto) !== -1) {
        this.tipoMsg.mostrarMsg(this.mObjGenerico.getTranslationsAlertRegistroExistente(contactoCliente.NombreClienteContacto));
        return true;
      }
    }

    return false;
  }

  public menuContextual(evt: any) {
    evt.event.preventDefault();
    this.disableContextMenu();
    this.disableAllContextMenu();
    this.menus = this.mObjCRUDCatalogos.crearMenuContextual({
      esCliente: false,
      esUnidad: false,
      esEmpresa: false
    }, this.infPpto.esPptoMaestro);
    this.lengthMenu = this.menus.filter(x => !x.disabled).length;
    this.contextmenuX = ClsUtil.calcPosition(document.body.clientWidth, evt.event.clientX, true, this.lengthMenu);
    this.contextmenuY = ClsUtil.calcPosition(document.body.clientHeight, evt.event.clientY, false, this.lengthMenu);
    this.cellMenuContextaul = evt.cell;
    this.verContextMenu = true;
  }

  public disableContextMenu() {
    if (this.verContextMenu) {
      this.verContextMenu = false;
    }
  }

  public disableAllContextMenu() {
    this.mObjGenerico.disableAllContextMenu(this.infPpto);
  }

  public handleRowSelection() {
    this.gridContactoClientes.nativeElement.focus();
  }

  public async onSelectionDropDown(opcion: string) {
    try {
      switch (opcion) {
        case EnumMasOpciones.Ajustar:
          const result: { themesClass: string, clicked: boolean } = ClsUtil.ajustarTexto(this.clicked);
          this.themesClass = result.themesClass;
          this.clicked = result.clicked;
          break;
        case EnumMasOpciones.ExportarExcel:
          const sms = await ClsUtil.exportarDatos(this.gridContactoClientes, this.mObjGenerico.getTranslationsGetCatalogos('MENSAJES.GRALS.CLIENTES'), this.excelExportService).then(sms => { return sms });
          this.tipoMsg.mostrarToast(this.mObjGenerico.getTranslationsSmsExportar(sms, this.gridContactoClientes.selectedRows.length));
          break;
        case EnumMasOpciones.ExportarPDF:
          await ClsUtil.abrirVentanaPersonalizarPDF(
            this.gridContactoClientes,
            this.mObjGenerico.getTranslationsGetCatalogos('MENSAJES.GRALS.CLIENTES'),
            this.pdfExportService,
            this.crearCompDinamico,
            this.tipoMsg,
            this.mObjGenerico
          );
          break;
        case EnumMasOpciones.Actualizar:
          await this.cargarContactoClientes();
          break;
        case EnumMasOpciones.LimpiarFiltroColumnas:
          this.clearInput();
          break;
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  public async accionSeleccionada(evt: INeodataGridCell) {
    try {
      switch (evt.accionMenu.id) {
        case EnumMCGenerales.Copiar:
          await this.copiarData();
          break;
        case EnumMCGenerales.Pegar:
          // let data: any = await navigator.clipboard.readText().then((data2) => data2);
          // data = this.pasteHandlerNeo.processData(data);
          // await this.datosPegadosDesdeExcel(data);
          break;
        case EnumMasOpciones.Ajustar:
          const result: { themesClass: string, clicked: boolean } = ClsUtil.ajustarTexto(this.clicked);
          this.themesClass = result.themesClass;
          this.clicked = result.clicked;
          break;
        case EnumMCGenerales.GuardarLayout:
          const state = this.state.getState(true);
          this.mObjConfigGrids.saveGridState(EnumNombresGrids.Clientes, false, '', state, !this.clicked);
          break;
        case EnumMCGenerales.ReestablecerLayout:
          this.restoreGrid();
          break;
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  public accionStripRowBtn(rowContext: RowType, indexBtn: number) {
    try {
      switch (indexBtn) {
        case 1:
          this.beginAddRowByIndexNeo(this.gridContactoClientes, rowContext.index);
          break;
        case 2:
          this.tipoMsg.mostrarQuestion((resp: boolean) => {
            if (resp) {
              this.eliminarContactoClientes(rowContext);
            }
          }, this.mObjGenerico.getTranslationsQuestionBorrar(rowContext.data.NombreClienteContacto));
          break;
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  public registroSeleccionado() {
    const rowSeleccionados: bigint[] = this.gridContactoClientes.selectedRows;
    try {
      if (rowSeleccionados.length === 0) {
        throw new Error('MENSAJES.ALERT.SELECCIONAR_REGISTRO');
      }
      const rowData = this.gridContactoClientes.getRowData(rowSeleccionados[0]);
      this.gridContactoClientes.doubleClick.emit(rowData);
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  public async copiarData() {
    try {
      this.tipoMsg.mostrarWaitDialog('MENSAJES.WAIT.COPIANDO');
      const msg: string = await ClsUtil.copiarDatosGrids(this.gridContactoClientes, 'IdClienteContacto', this.mObjGenerico);
      msg && this.tipoMsg.mostrarToast(msg);
    } catch (e) {
      throw new Error(e.message);
    } finally {
      this.tipoMsg.cerrarWaitDialog();
    }
  }

  public clearInput() {
    this.filtroGeneral.input.value = '';
    this.gridContactoClientes.clearFilter();
  }

  public restoreGrid() {
    const stateDefault = this.mObjConfigGrids.restoreGrid(EnumNombresGrids.Clientes);
    if (!ClsUtil.esNulo(stateDefault[0])) {
      this.state.setState(stateDefault[0]);
    }
    this.clicked = stateDefault[1];
    const result: { themesClass: string, clicked: boolean } = ClsUtil.ajustarTexto(this.clicked);
    this.themesClass = result.themesClass;
    this.clicked = result.clicked;
  }
}
